/*
 * @Author: dinglizu
 * @Date: 2022-04-22 20:34:54
 * @LastEditTime: 2023-02-13 15:04:32
 * @LastEditors: dinglizu
 * @Description: 
 */
import Vue from 'vue'
import Vuex from 'vuex'
import * as getters from './getters'
import * as mutations from './mutations'
import * as actions from './actions'
import createPersistedState from "vuex-persistedstate"
Vue.use(Vuex)

const store = new Vuex.Store({
  /** 
   * 定义状态
   * currentUser 存的用户昵称
   * isLogin 是否登录 true登录，false未登录
   * token 登录后的token
   * toeflModel 记录跳转到哪个选项卡下
   * dictationModel 记录精听跟读内容
   * routeName 记录当前路由名称
   * userVip 是否是vip
  */
  state: {
    token: null,
    aliyunDeviceCode: [],
    userInfo: null,
    toeflModel: {},
    dictationModel: {},
    testReport: null,
    browse: null,
    practice: null,
    card: null,
    routeName: null,
    globalConfig: { language: 'zh_CN' },
    orgInfo: {}
  },
  getters,
  mutations,
  actions,
  plugins: [new createPersistedState({
    storage: window.localStorage
  })]
})

export default store


// WEBPACK FOOTER //
// ./src/vuex/store.js